import {makeStyles} from '@material-ui/core/styles';

export default makeStyles(theme => ({
  paper: {
    padding: theme.spacing(1),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  grid: {
    minHeight: '95%',
    maxHeight: '90vh',
  },
  gridLeft: {
    maxHeight: '92vh',
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      minHeight: 400,
      height: '40vh'
    },
  },
  gridRight: {
    minHeight: '92vh',
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      minHeight: 600,
    },
  }
}));
